export default [
    {
        path: 'parametrizacao',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-parametrizacao' */
            '@/views/pronto-atendimento/parametrizacao/Index'
        ),
        redirect: 'parametrizacao/create',
        children: [
            {
                name: 'pronto-atendimento-parametrizacao-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-parametrizacao' */
                    '@/views/pronto-atendimento/parametrizacao/Form.vue'),
            },
        ]
    }
]